export var Status;
(function (Status) {
    Status["Loading"] = "Status/Loading";
    Status["Error"] = "Status/Error";
    Status["Successful"] = "Status/Successful";
})(Status || (Status = {}));
